module.exports = __webpack_public_path__ + "static/media/promo3.fcb1e2e2.svg";